/* eslint-disable array-bracket-newline */
import { KattanaAPI } from '../../store/createStore';
import { useEffect, useState } from 'react';
import BigNumber from 'bignumber.js';

interface ITokenBalance {
  network: string;
  address: string;
  wallet: string;
  decimals: number;
}

/**
 * Token balance for EVM
 * @param props
 * @returns
 */
const TokenBalance = ({
  network,
  address,
  wallet,
  decimals,
}: ITokenBalance) => {
  const [loading, setLoading] = useState<Boolean>(true);
  const [value, setValue] = useState<string>('...');

  useEffect(() => {
    setLoading(true);
    KattanaAPI.tokenBalanceForWallet(network, address, wallet)
      .then((balance: string | null) => {
        if (balance) {
          const rawBalance = BigNumber(balance);
          const denom = BigNumber(10).pow(decimals);
          setValue(rawBalance.dividedBy(denom).toFixed(2));
        } else {
          setValue('0');
        }
      })
      .catch(() => {
        setValue('0');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [network, address, wallet, decimals]);

  return <span>{value}</span>;
};

export default TokenBalance;
